import { FieldValidationRules } from "../types";

export const GPLUValidationRules: Record<string, FieldValidationRules> = {
  'GPLUAcceleratedBenefitOptions.maxAcceleratedBenefitPct': {
    required: true,
    min: 0,
    max: 100,
    step: 5,
    errorMessages: {
      required: "'Accelerated Benefit Maximum Percentage' Value is required",
      minMax: `The value must be between 0% and 100% with step 5`,
    },
  },

};